import { Link, useNavigate } from "react-router-dom";
import { TriangleAlert } from "lucide-react";
import { defineModuleUi, useOrg } from "@vixio/data";
import { lazyPage } from "@vixio/ui";
import { RiskMatrix } from "./Matrix";
import { RisksPage, useMatrix, useRisks } from "./RisksPage";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const RiskPage = lazyPage(() => import("./RiskPage"), "RiskPage");

function RisksWidget() {
  const org = useOrg();
  const navigate = useNavigate();
  const matrix = useMatrix(org.id);
  const risks = useRisks(org.id).data ?? [];
  const overdue = risks.filter((r) => r.status === "ativo" && r.review_overdue).length;
  return (
    <div className="vx-stack" style={{ gap: 8 }}>
      <RiskMatrix compact cells={matrix.data ?? []} onSelect={(c) => c && navigate(`/gestao/riscos?p=${c.probability}&i=${c.impact}`)} />
      <p className="text-2" style={{ margin: 0, fontSize: "var(--fs-12)" }}>
        <Link to="/gestao/riscos">{risks.filter((r) => r.status === "ativo" && r.level === "critico").length} crítico(s)</Link>
        {overdue ? ` · ${overdue} revisão(ões) atrasada(s)` : " · revisões em dia"}
      </p>
    </div>
  );
}

export default defineModuleUi({
  key: "risks",
  title: "Riscos",
  domain: "governance",
  icon: TriangleAlert,
  menu: [{ path: "/gestao/riscos", label: "Riscos", minRole: "member", icon: TriangleAlert, order: 40, keywords: "matriz probabilidade impacto mitigação sinal de alerta revisão" }],
  routes: [
    { path: "/gestao/riscos", element: <RisksPage />, minRole: "member" },
    { path: "/gestao/riscos/:id", element: <RiskPage />, minRole: "member" },
  ],
  widgets: [{ key: "risks.matrix", title: "Matriz de riscos", minRole: "member", span: 1, order: 74, element: RisksWidget }],
});
